import Route from '@ember/routing/route';
import logger from 'donor-elf-web/lib/logger';

export default Route.extend({
  setupController(controller, error) {
    logger.error(error);
    this._super(...arguments);
  },
});
